import { ActivitiesView } from '@/components/activities/activities-view'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/dashboard_/activities')({
  component: RouteComponent,
  beforeLoad: ({ context: { user } }) => {
    if (user?.isAdmin) throw redirect({ to: '/sign-out' })
    return { breadcrumb: 'Activities', user }
  },
  loader: async ({ context: { orpc, queryClient, user } }) => {
    await queryClient.ensureQueryData(
      orpc.backoffice.activities.getAll.queryOptions({
        input: { villageId: user!.village!.id }
      })
    )
  }
})

function RouteComponent() {
  const { user, orpc } = Route.useRouteContext()

  return <ActivitiesView user={user} orpc={orpc} />
}
